import { render, staticRenderFns } from "./Automotive.vue?vue&type=template&id=d40716ac&"
import script from "./Automotive.vue?vue&type=script&lang=js&"
export * from "./Automotive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d40716ac')) {
      api.createRecord('d40716ac', component.options)
    } else {
      api.reload('d40716ac', component.options)
    }
    module.hot.accept("./Automotive.vue?vue&type=template&id=d40716ac&", function () {
      api.rerender('d40716ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/Automotive.vue"
export default component.exports